import { UserType } from 'api'

export namespace permissions {
  export const canViewStatistics: UserType[] = [UserType.OWNER, UserType.ADMIN, UserType.DEBUG]
}

export default permissions
